import React, { useState } from "react"
import { Button, Col, FormGroup, Label, Modal, ModalBody, Row } from "reactstrap"
import { useResponse } from "../../../../hooks/useResponse"
import { getDutchInvoicePdf, getInvoicePdf } from "../../../../api/invoices"
import ReactSelect from "react-select"
import { languageTempletsOptions } from "../../../../utils/langTemplets"

const PrintInvoiceModal = ({handleClose, isOpen, invoice}) => {

  const [template, setTemplate] = useState(null)

  const firstHourCollectionName = invoice?.invoiceablesDays?.filter((inv) => inv.collection_id && inv.totalHours > 0)[0]?.name || ""

  const {loading, error, setData} = useResponse(template?.value == 'nlII' ? getDutchInvoicePdf : getInvoicePdf, (res) => {
    const blob = new Blob([res], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `invoice ${firstHourCollectionName}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    handleClose()
    setTemplate(null)
  })

  function handlePrint() {
    setData({type: "edit", id: invoice?.id, data: {templateKey: template?.value || null}})
  }

  return (
    <Modal isOpen={isOpen} toggle={handleClose} centered={true}>
      <ModalBody className="py-5 px-5">
        <h2 className="text-center mb-4">Printing Invoice</h2>
        
        <Row>
          <Col md={12}>
            <FormGroup className="">
                <Label>Template:</Label>
                <ReactSelect
                  options={languageTempletsOptions}
                  value={template}
                  onChange={(op) => setTemplate(op)}
                  isSearchable={false}
                  isClearable={true}
                />
            </FormGroup>
          </Col>
        </Row>          
      
        <div className="mt-4 d-flex gap-4 align-items-center justify-content-center">
          <Button
            onClick={handlePrint}
            color="primary"
            size="lg"
            disabled={loading}
          >
            {loading ? "Printing..." : "Print"}
          </Button>
          <Button onClick={handleClose} color="dark" size="lg">
            Cancel
          </Button>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default PrintInvoiceModal
